import type { TFunction } from 'i18next';

/** The `error` the Shopify install comes back with, as a sentence. */
export function shopifyConnectErrorMessage(error: string, t: TFunction): string {
  const messages: Record<string, string> = {
    invalid_state: t('onboarding.shopify.errors.invalidState'),
    state_expired: t('onboarding.shopify.errors.stateExpired'),
    missing_state: t('onboarding.shopify.errors.missingState'),
    integration_failed: t('onboarding.shopify.errors.integrationFailed'),
    callback_failed: t('onboarding.shopify.errors.callbackFailed'),
    redirect_failed: t('onboarding.shopify.errors.integrationFailed'),
  };

  return messages[error] ?? t('onboarding.shopify.errors.connectionFailed');
}
